export default __webpack_public_path__ + "static/media/Corporate and TPA Business Tie-Ups.a5d45dc5.png";